// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"search_error_message-module__errorContainer--1oDOe","error":"search_error_message-module__error--2jZVY"};